import { ContentClipSort, ContentEngineTier, ContentExperimentStatus, ContentNetwork, ContentSortDir, } from '@wit-support/admin-contracts';
import { readBool, readEnum, readPage, readPageSize, readString } from '../url-search.js';
/**
 * Состояние экранов «Клипы» и «Эксперименты» в строке адреса. Чтение и запись
 * поиска — общий помощник модуля `url-search.ts`; здесь только разбор
 * параметров этих экранов (мусор в адресе — значение по умолчанию).
 */
// ---------------------------------------------------------------------------
// «Клипы»
// ---------------------------------------------------------------------------
/**
 * Порядок по умолчанию — «Просмотры первым» по убыванию: главная колонка
 * экрана, первым видно клипы, которые реально приносят просмотры.
 */
export const DEFAULT_CLIPS_SORT = { key: 'viewsAsHook', dir: 'desc' };
export function readClipsSearch(s) {
    const key = readEnum(ContentClipSort.options, s.sort);
    const dir = readEnum(ContentSortDir.options, s.dir);
    return {
        account: readString(s.account),
        q: readString(s.q),
        sort: key ? { key, dir: dir ?? (key === 'name' ? 'asc' : 'desc') } : DEFAULT_CLIPS_SORT,
        tier: readEnum(ContentEngineTier.options, s.tier),
        network: readEnum(ContentNetwork.options, s.network),
        overridesOnly: readBool(s.overridesOnly),
        page: readPage(s.page),
        pageSize: readPageSize(s.pageSize),
    };
}
export function readExperimentsSearch(s) {
    return {
        status: readEnum(ContentExperimentStatus.options, s.status),
        page: readPage(s.page),
        pageSize: readPageSize(s.pageSize),
    };
}
//# sourceMappingURL=clips-url.js.map